import { PRODUCT_REVIEWS_API_URL, fetchReviewList } from 'webwinkelkeur-api';

const MIN_RATING = 4;
const MAX_REVIEWS = 5;

class ProductReviews extends HTMLElement {
  async connectedCallback() {
    this.list = this.querySelector('[data-product-reviews-list]');
    this.template = this.querySelector('template[data-product-reviews-item]');

    if (!this.list || !this.template) return;

    try {
      const reviews = await this.fetchReviews();
      if (!reviews.length) return;

      this.renderReviews(reviews);
      this.updateCount(reviews.length);
      this.hidden = false;
    }
    catch (error) {
      // Leave the element (and its collapsible row) hidden when the API is unavailable
      console.warn('Product reviews could not be loaded:', error);
    }
  }

  async fetchReviews() {
    return fetchReviewList(PRODUCT_REVIEWS_API_URL, {
      params: { product_id: this.dataset.productId },
      listKey: 'product_reviews',
      // The API includes deleted reviews in the results (and in `total`)
      keep: review => (!review.deleted && review.rating >= MIN_RATING ? review : null),
      max: MAX_REVIEWS,
    });
  }

  renderReviews(reviews) {
    for (const review of reviews) {
      const item = this.template.content.cloneNode(true);

      item.querySelector('[data-product-review-stars-filled]').style.inlineSize = `${review.rating * 20}%`;
      item.querySelector('[data-product-review-rating]').textContent = `${review.rating}/5`;
      item.querySelector('[data-product-review-name]').textContent = review.reviewer?.name ?? '';
      item.querySelector('[data-product-review-text]').textContent = this.reviewText(review);

      this.list.append(item);
    }
  }

  // Reviews can be written in another language than the page; prefer the translation matching the page locale
  reviewText(review) {
    const locale = this.dataset.locale;
    if (review.language === locale) return review.review;
    return review.translations?.[locale] || review.review;
  }

  updateCount(count) {
    const countElement = this.closest('.collapsible-row')?.querySelector('[data-product-reviews-count]');
    if (countElement) countElement.textContent = `(${count})`;
  }
}

if (!customElements.get('product-reviews')) {
  customElements.define('product-reviews', ProductReviews);
}

// The rating stars in the product title link to the reviews collapsible row.
// Open the <details> before the browser follows the anchor, otherwise it scrolls to a closed row
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-product-rating-link]');
  if (!link) return;

  const target = document.querySelector(link.getAttribute('href'));
  const details = target?.closest('details');
  if (details) details.open = true;
});
